import { useQuery } from "@apollo/client/react"; import { useEffect, useState } from "react";

import { adaptEstadosRIArray, GET_ESTADOS_RI } from "../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getEstadosRI";
import { GET_ALL_ESTADOS_VALIDACION } from '../../../data/graphQL/queries/ResumenIngresoValidation/getAllEstadosValidacion';
import { data } from "react-router-dom";

export const useGetEstados = () => {
  const [estadosValidacion, setEstadosValidacion] = useState([]);
  const [estadosRI, setEstadosRI] = useState([]);

  const { loading: loadingDataRI, data: dataEstadosRI } = useQuery(GET_ESTADOS_RI, {
    fetchPolicy: 'no-cache'
  });

  const { loading: loadingDataValidacion, data: dataEstadosValidacion } = useQuery(GET_ALL_ESTADOS_VALIDACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataEstadosRI) return;

    setEstadosRI(adaptEstadosRIArray(dataEstadosRI));
  }, [dataEstadosRI]);

  useEffect(() => {
    if (!dataEstadosValidacion) return;

    setEstadosValidacion(dataEstadosValidacion?.allEstadosValidacion);
  }, [dataEstadosValidacion]);

  return {
    estadosValidacion,
    estadosRI,
    loadingEstados: loadingDataRI || loadingDataValidacion
  };
};